import * as React from "react";

function getFileFromDragEvent(event: React.DragEvent<any>): File | null {
  if ((event as any).__testFile) {
    return (event as any).__testFile;
  }

  if (event.dataTransfer.items) {
    return event.dataTransfer.items[0].getAsFile();
  }
  return event.dataTransfer.files[0];
}

function clearDragData(event: React.DragEvent<any>): void {
  if (!event.dataTransfer) {
    return;
  }

  if (event.dataTransfer.items) {
    event.dataTransfer.items.clear();
  } else {
    event.dataTransfer.clearData();
  }
}

export default function useFileDrop(onFile: (file: File) => void) {
  const [isOver, setOver] = React.useState(false);

  const memoOnFile = React.useCallback(onFile, []);

  return {
    isOver,
    bind: {
      onDragOver: (evt: React.DragEvent) => evt.preventDefault(),
      onDragEnter: () => setOver(true),
      onDragLeave: () => setOver(false),
      onDrop: (evt: React.DragEvent) => {
        evt.preventDefault();
        setOver(false);
        const possibleFile = getFileFromDragEvent(evt);
        clearDragData(evt);

        if (possibleFile) {
          memoOnFile(possibleFile);
        }
      }
    }
  };
}
